import React from 'react';
import styles from './Welcome2.module.scss'
import { Container, Nav, Navbar } from 'react-bootstrap';
import shadows from './shadows.png';
import lakes from './lakes.png';
import yellow from './yellow.png';
import { Link } from 'react-router-dom';
import { FaTwitter, FaInstagram, FaLinkedin, FaInstagramSquare } from 'react-icons/fa';
import { GrInstagram } from 'react-icons/gr';
import image from './shadows.png'
import { motion } from "framer-motion"
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


const products = {
    initial: { y: -20, opacity: 0 },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.7,
            ease: [0.6, -0.05, 0.01, 0.99],
        },
    },
};

export const Welcome2 = (props) => (
    <motion.div exit={{ opacity: 0 }}>
        <img
            className={styles.coverImage}
            alt="Skippy"
            src={image}
        >
        </img>
        <div className={styles.coverContent}>
            <Link className={styles.header} to="/about">
                susanna byrne
            </Link>
            <motion.div
                variants={products}
                className="text-gray-700 body-font"
            >
                <div className={styles.BtnWrap}>
                    <Container>
                        <Row className='justify-content-md-center'>
                            <Col sm={6} md={5} lg={4}>
                                <Link className={styles.Button} to="/about">
                                    about me
                                </Link>
                            </Col>
                            <Col sm={6} md={5} lg={4}>
                                <Link className={styles.Button} to="/gallery">
                                    gallery
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </motion.div>
            <a className={styles.SocialIconLink1} href="//www.instagram.com/wilkes.and.weaver" target="_blank" aria-label="Instagram">
                <GrInstagram />
            </a>
            <a className={styles.SocialIconLink2} href="//www.twitter.com/susannabyrne" target="_blank" aria-label="Twitter">
                <FaTwitter />
            </a>
            <a className={styles.SocialIconLink3} href="//www.linkedin.com/in/susanna-byrne-2394242b" target="_blank" aria-label="Instagram">
                <FaLinkedin />
            </a>
        </div>
    </motion.div>
)
